import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { MessageCircle, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { FAQS, WHATSAPP_URL, PHONE, PHONE_TEL } from "../mock";

const Faq = () => {
  return (
    <section id="faq" className="py-14 md:py-24 bg-[#0a0f1c]">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center text-red-400 text-[11.5px] tracking-[0.22em] uppercase font-medium">FAQ</div>
        <h2 className="mt-3 text-center text-white text-[34px] md:text-[42px] font-semibold leading-[1.1] tracking-tight">
          Everything you wanted to ask
        </h2>
        <p className="mt-4 text-center text-slate-300">
          Still unsure? Our team replies on WhatsApp within minutes during business hours.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild className="h-11 rounded-full bg-red-500 hover:bg-red-600 text-white px-5">
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2">
              <MessageCircle className="h-4 w-4" /> Ask on WhatsApp
            </a>
          </Button>
          <Button asChild variant="outline" className="h-11 rounded-full bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-white px-5">
            <a href={`tel:${PHONE_TEL}`} className="inline-flex items-center gap-2">
              <Phone className="h-4 w-4" /> Call {PHONE}
            </a>
          </Button>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f) => (
            <AccordionItem
              key={f.q}
              value={f.q}
              className="rounded-2xl border border-white/8 bg-[#0e1626]/70 px-5"
            >
              <AccordionTrigger className="text-left text-white text-[15.5px] font-medium hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-300 text-[14.5px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
